//import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../_models/user';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private languages: string[] = ['en', 'es', 'it', 'en-mtc'];

  constructor ( private translate: TranslateService,
                private appService: AppService
              ) {}

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

  setDefaultLanguage(lang: string, additionalLang : string) {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang(lang);
    this.translate.use(additionalLang != '' ? additionalLang : lang);
  }

  checkLanguage() {
    let currentUser: User = JSON.parse(localStorage.getItem('user'));
    
    if (currentUser?.locationRoles != null && currentUser?.selectedLocationIndex != null) 
    {
      let currentLocation = currentUser.locationRoles[currentUser.selectedLocationIndex];
      if (!!!this.languages.find((f) => currentLocation.Language.includes(f))) 
      {
        this.checkNavigatorLang();
      } 
      else 
      {
        //Cambio de estructura condicional para admitir posibles futuras modificaciones de idioma en otras Locations
        switch (this.appService.getCurrentRegion().toUpperCase()){
          case 'MTC':
            this.setDefaultLanguage(currentLocation.Language, 'en-mtc');
            break;
          default:
            this.setDefaultLanguage(currentLocation.Language, '');
            break;
        }
      }
    } 
    else {
      this.checkNavigatorLang();
    }
  }

  checkNavigatorLang() {
    const lang = window.navigator['userLanguage'] || window.navigator.language;
    let findLang = this.languages.find((f) => lang.includes(f));

    if (!!!findLang) {
      findLang = 'en';
    }

    this.setDefaultLanguage(findLang, '');
  }
}
